import React from 'react';
import { DateFormat } from '../../../utilities/dataFormat';
import { renderDate } from '../../../utilities/renderDate';

interface LabelDateProps {
  date?: string;
  locale?: string;
  type?: DateFormat | string;
}

const LabelDate: React.FC<LabelDateProps> = ({
  date,
  locale,
  type = 'datetimeyear'
}) => {
  if (!date) return <>-</>;
  return <>{renderDate(date, type, locale)}</>;
};

export default LabelDate;
